import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArtificialIntel = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      strokeLinejoin="round"
      d="M5.5 11.997a.5.5 0 0 1 .472-.496h.005l.024-.002a8.184 8.184 0 0 0 .458-.045c.308-.037.73-.098 1.19-.2.95-.207 1.948-.56 2.497-1.107l.101-.109c.495-.569.833-1.521 1.045-2.431a13.456 13.456 0 0 0 .28-1.71V5.89l.018-.097a.5.5 0 0 1 .967.015l.013.097h.001v.03l.008.098a13.116 13.116 0 0 0 .217 1.583c.195.97.533 1.984 1.064 2.536.253.262.632.49 1.094.68a8.45 8.45 0 0 0 1.449.426 13.346 13.346 0 0 0 1.63.233l.102.007.026.002h.007l.097.014a.5.5 0 0 1-.002.97l-.097.014h-.006l-.025.002a8.144 8.144 0 0 0-.476.042 12.97 12.97 0 0 0-1.233.194c-.922.193-1.886.514-2.463 1.014l-.11.103c-.556.557-.892 1.567-1.08 2.53a12.144 12.144 0 0 0-.2 1.67l-.002.024v.007a.5.5 0 0 1-1 .016v-.03l-.009-.099a12.373 12.373 0 0 0-.248-1.58c-.204-.904-.54-1.851-1.055-2.423l-.106-.109c-.557-.536-1.561-.889-2.51-1.102a13.132 13.132 0 0 0-1.552-.248l-.096-.01H5.966v-.001a.5.5 0 0 1-.466-.502Z"
    />
    <circle cx="17.5" cy="6.5" r="1" strokeLinejoin="round" />
  </SvgIcon>
);

export default ArtificialIntel;
